// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'es6-promise/auto'

import $ from 'jquery'

window.$ = $
window.PREFIX = "v2_"

import Vue from 'vue'

import VueBus from 'vue-bus'
import Vuex from 'vuex'
import VueHead from 'vue-head'
import UUID from 'vue-uuid'
import ElementUI from 'element-ui'
import VTooltip from 'v-tooltip'
import VueGtag from "vue-gtag"
console.log(VueGtag)
import App from './App'
console.log(App)



import router from './router'

import PrettyCheckbox from 'pretty-checkbox-vue'
import Notifications from 'vue-notification'
import VueResource from "vue-resource"
import VueCarousel from 'vue-carousel'
import slugify from "@/components/services/Slug"
import Wagtail from "@/components/services/Wagtail"
import SocialSharing from "vue-social-sharing"
import { findContext } from "@/components/services/Tools"
import 'element-ui/lib/theme-chalk/index.css'

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(PrettyCheckbox)
Vue.use(Vuex)
Vue.use(VTooltip)
Vue.use(VueCarousel)
Vue.use(UUID)
Vue.use(VueResource)
Vue.use(Notifications)
Vue.use(SocialSharing)
Vue.use(VueBus)
Vue.use(require('@websanova/vue-upload'))

let token = null
let type = null
let prevToken = localStorage.getItem(window.PREFIX + "token")
let prevType = localStorage.getItem(window.PREFIX + "type")

if (prevToken) token = prevToken
if (prevType) type = prevType

// Set title of the mainpage
const metaTitle = (findContext() == "esreps") ? "Federación Española de Fitness" : "Asociación Colombiana de Fitness"

Vue.use(VueHead, {
  separator: "-",
  complement: metaTitle,
})

// Global filters
Vue.filter("slug", value => {
  return slugify(value)
})

// Injects on the $vue instance
Vue.prototype.$wagtail = Wagtail

// Application
const store = new Vuex.Store({
  state: {
    token,
    type,
    context: findContext(),
  },
  mutations: {
    set_token: (state, payload) => {
      state.token = payload
      localStorage.setItem(window.PREFIX + "token", payload)
    },
    set_type: (state, new_type) => {
      state.type = new_type
      localStorage.setItem(window.PREFIX + "type", new_type)
    }
  },
})

let hostname = window.location.hostname
if (/www\.fedfitness\.org/.test(hostname)) {
  Vue.use(VueGtag, {
    config: { id: "UA-154845070-1" }
  }, router)

  setTimeout(function() {
    mt('send', 'pageview')
  }, 1000)
}

/eslint-disable no-new /
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App :class="currentContext" />',
  data: function() {
    return {
      currentContext: "",
    }
  },
  created() {
    this.currentContext = "app-" + this.$store.state.context
  }
})
/*
//Vue 2

import * as Sentry from "@sentry/vue";
import { BrowserTracing } from "@sentry/tracing";

Sentry.init({
  Vue,
  dsn: "https://20d167b49b324e6ea5abdc86275a79ee@o1429292.ingest.sentry.io/4503908925833216",
  integrations: [
    new BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracingOrigins: ["localhost", "my-site-url.com", /^\//],
    }),
  ],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});

// ...

new Vue({
  router,
  render: h => h(App),
}).$mount("#app");

*/

/*
//Vue3
import * as Sentry from "@sentry/vue";
import { BrowserTracing } from "@sentry/tracing";

Sentry.init({
  app,
  dsn: "https://20d167b49b324e6ea5abdc86275a79ee@o1429292.ingest.sentry.io/4503908925833216",
  integrations: [
    new BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracingOrigins: ["localhost", "my-site-url.com", /^\//],
    }),
  ],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});

app.use(router);
app.mount("#app");
*/


// WEBPACK FOOTER //
// ./src/main.js